<script>
    import FormInputMixin from './Input.vue';
    export default {
        mixins: [FormInputMixin],
        data() {
            return {
                inputType: 'text'
            }
        },
        mounted() {
            this.update(this.initialValue);
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/src/mixins/Form/TextInput.vue